import { ValueFormatterParams } from 'ag-grid-community';

export function linkFormatter(params: ValueFormatterParams): string {
  let val = _.get(params.data, params.colDef.field);
  let template = `
    <div class="inner-cell">
      <a href="${(params.colDef as any).href}${params.value}">${params.value}</a>
    </div>
  `;
  return val ? template : '';
}
